<script lang="ts">
    import { cx } from '$lib/utils/cx.js';
</script>

<div
    class={cx(
        'my-5 bg-white/50 p-2 border rounded-lg border-gray-300_ shadow_ boxify_ text-transparent',
    )}
>
    <div class="flex mb-8 items-start space-x-5">
        <div
            class={'force-w-16 ls:force-w-24 force-h-16 ls:force-h-24 rounded-full bg-gray-300 animate-pulse'}
        />
        <div class={'flex-1 relative overflow-hidden'}>
            <div class="text-12 font-bold truncate">
                <span class={'bg-gray-300 animate-pulse rounded-md'}
                    >Author name here</span
                >
            </div>
            <div class={'italic text-12 truncate'}>
                <span class={'bg-gray-300 animate-pulse rounded-md'}
                    >Author title will come here</span
                >
            </div>
        </div>
    </div>
</div>
